import React from 'react';

function Spinner({ size = 20 }) {
  return <div data-testid="spinner" className="loader" style={{ width: size, height: size, borderWidth: size / 5 }} />;
}

export default Spinner;
